// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".idc-promotions .btn-icon-wrapper{z-index:11}.idc-promotions .btn-icon-wrapper .btn-transparent.btn-icon:hover{--tw-bg-opacity:0}@media (max-width:576px){.idc-promotion.sticky .idc-promotion-item{padding-top:.75rem}.idc-promotion.sticky .banner-title{margin-top:.75rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
